import { INPUT_AUTOCOMPLETE, INPUT_TYPE, schemas } from '@nandosaus/constants';
import PropTypes from 'prop-types';

import { A, P } from '../typography';
import { Box } from '../grid';
import { Form } from '../form';
import { FormikTextInput } from '../input';

const ResetCodeForm = ({ error, username, handleOnSubmit, handleResendCode }) => (
  <>
    <Form
      initialValues={{ newPassword: '', confirmPassword: '', code: '', mobile: '', email: null }}
      onSubmit={handleOnSubmit}
      validationSchema={schemas.confirmForgotPassword}
      heading="Forgot Password"
      paragraph={
        <P textAlign="center" mb={2}>
          A reset password code was sent to <b>{username}</b>
        </P>
      }
      buttonText="Reset password"
      error={error}
    >
      <>
        <Box mb={1}>
          <FormikTextInput
            name="code"
            label="Reset Code"
            maxLength={6}
            placeholder="Enter 6 digit code"
            autoComplete={INPUT_AUTOCOMPLETE.ONE_TIME_CODE}
          />
        </Box>
        <Box mb={1}>
          <FormikTextInput
            name="newPassword"
            label="Create new password"
            type={INPUT_TYPE.PASSWORD}
            autoComplete={INPUT_AUTOCOMPLETE.NEW_PASSWORD}
          />
        </Box>
        <Box mb={1}>
          <FormikTextInput
            name="confirmPassword"
            label="Confirm new password"
            type={INPUT_TYPE.PASSWORD}
            autoComplete={INPUT_AUTOCOMPLETE.NEW_PASSWORD}
          />
        </Box>
      </>
    </Form>
    <P variant={2} textAlign="center" mt={1}>
      Didn’t receive an email?{' '}
      <A variant={2} onClick={handleResendCode}>
        Resend code
      </A>
    </P>
  </>
);

ResetCodeForm.propTypes = {
  error: PropTypes.string,
  username: PropTypes.string.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleResendCode: PropTypes.func.isRequired,
};

ResetCodeForm.defaultProps = {
  error: null,
};

export { ResetCodeForm };
